/* global window: true, document: true */
import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';

import SalesTv from './components/SalesTv/SalesTv';
import LoginForm from './components/LoginForm/LoginForm';
import './styles/main.scss';

require('../node_modules/react-grid-layout/css/styles.css');
require('../node_modules/react-resizable/css/styles.css');

// Container for react-router
const App = props => (
    <div>
        {props.children}
    </div>
);

App.propTypes = {
    children: React.PropTypes.object.isRequired,
};

render((
    <Router history={browserHistory}>
        <Route path="" component={App}>
            <Route path="login" component={LoginForm} />
            <Route path=":tvIndex" component={SalesTv} />
            <Route path="*" component={SalesTv} />
        </Route>
    </Router>
), document.getElementById('js-main'));




/** WEBPACK FOOTER **
 ** ./client/main.jsx
 **/